"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotePane = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const web_conversation_views_1 = require("@opsbase/web-conversation-views");
const MessageIcon_1 = __importDefault(require("@opsbase/web-icons/icons/MessageIcon"));
const react_1 = __importStar(require("react"));
require("react-quill/dist/quill.snow.css");
const InnerPane_1 = __importDefault(require("./InnerPane"));
function NotePane({ onClickClose }) {
    const { id, isPreview, mode } = (0, usePerform_1.default)();
    const { question, answer } = (0, usePerformQuestion_1.default)();
    const viewMode = mode === 'view';
    const { doChangeAnswer } = (0, usePerformQuestionActions_1.default)();
    const onChangeConversation = (0, react_1.useCallback)(newConversationId => doChangeAnswer({ conversationId: newConversationId }), [doChangeAnswer]);
    const handleClickDelete = (0, react_1.useCallback)(() => {
        onClickClose();
        doChangeAnswer({ conversationId: null });
    }, [doChangeAnswer, onClickClose]);
    const { conversationId } = answer !== null && answer !== void 0 ? answer : {};
    const { title: questionTitle } = question !== null && question !== void 0 ? question : {};
    return (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(InnerPane_1.default, { label: lib_i18n_1.default.t('notes'), icon: react_1.default.createElement(MessageIcon_1.default, { size: 18 }), onClickClose: onClickClose, onClickDelete: handleClickDelete, showDelete: !viewMode && !!(answer === null || answer === void 0 ? void 0 : answer.conversationId) },
            react_1.default.createElement(web_conversation_views_1.ConversationContainer, { id: conversationId, title: questionTitle, onConversationCreated: onChangeConversation, invertLayout: true, simpleCallouts: true, relatedOpId: !isPreview ? id : null, editable: !viewMode })));
    }, [
        answer.conversationId,
        conversationId,
        viewMode,
        handleClickDelete,
        id,
        isPreview,
        onChangeConversation,
        onClickClose,
        questionTitle,
    ]);
}
exports.NotePane = NotePane;
exports.default = NotePane;
